import React from 'react';
import { motion } from 'framer-motion';

const WelcomeHeader = ({ 
  userProfile = {}, 
  title = "¿Qué deseas hoy?",
  className = "",
  animationDelay = 0 
}) => {
  // Obtener el nombre del usuario con fallbacks
  const getUserName = () => {
    return userProfile.displayName || 
           userProfile.firstName || 
           userProfile.fullName || 
           'Usuario';
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: animationDelay }}
      className={`text-center ${className}`}
    >
      <h1 className="text-2xl sm:text-4xl font-bold text-gray-800 my-3 sm:my-4 px-2">
        ¡Hola, {getUserName()}!
      </h1>
      <p className="text-gray-600 text-base sm:text-lg max-w-3xl mx-auto px-2">
        {title}
      </p>
    </motion.div>
  );
};

export default WelcomeHeader;
